export default "__VITE_ASSET__DxFTEVv6__"